export const SAVE_CURRENT_ROUTE = 'SAVE_CURRENT_ROUTE';

export function saveCurrentRoute(route) {
  return {
    type: SAVE_CURRENT_ROUTE,
    payload: {
      route,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/routes.js